import React from 'react';
import { PERMISSION } from 'pages/CustomerLead/utils/constants';

const CustomerLead = React.lazy(() => import('pages/CustomerLead/pages/CustomerLead'));
const CustomerLeadAdd = React.lazy(() => import('pages/CustomerLead/pages/CustomerLeadAdd'));

const customerLeadRoute = [
  {
    path: '/customer-lead',
    exact: true,
    name: 'Danh sách lead cá nhân',
    function: PERMISSION.VIEW,
    component: CustomerLead,
  },
  {
    path: '/lead-individual',
    exact: true,
    name: 'Danh sách lead cá nhân',
    function: PERMISSION.VIEW,
    component: CustomerLead,
  },
  {
    path: '/lead-business',
    exact: true,
    name: 'Danh sách lead doanh nghiệp',
    function: PERMISSION.VIEW,
    component: CustomerLead,
  },
  {
    path: '/walk-in',
    exact: true,
    name: 'Danh sách Walk-in',
    function: PERMISSION.VIEW,
    component: CustomerLead,
  },
  {
    path: '/customer-lead/add',
    exact: true,
    name: 'Thêm mới lead cá nhân',
    function: PERMISSION.ADD,
    component: CustomerLeadAdd,
  },
  {
    path: '/lead-individual/add',
    exact: true,
    name: 'Thêm mới lead cá nhân',
    function: PERMISSION.ADD,
    component: CustomerLeadAdd,
  },
  {
    path: '/lead-business/add',
    exact: true,
    name: 'Thêm mới lead doanh nghiệp',
    function: PERMISSION.ADD,
    component: CustomerLeadAdd,
  },
  {
    path: '/walk-in/add',
    exact: true,
    name: 'Thêm mới Walk-in',
    function: PERMISSION.ADD,
    component: CustomerLeadAdd,
  },
  {
    path: '/customer-lead/edit/:data_leads_id',
    exact: true,
    name: 'Chỉnh sửa lead cá nhân',
    function: PERMISSION.EDIT,
    component: CustomerLeadAdd,
  },
  {
    path: '/lead-individual/edit/:data_leads_id',
    exact: true,
    name: 'Chỉnh sửa lead cá nhân',
    function: PERMISSION.EDIT,
    component: CustomerLeadAdd,
  },
  {
    path: '/lead-business/edit/:data_leads_id',
    exact: true,
    name: 'Chỉnh sửa lead doanh nghiệp',
    function: PERMISSION.EDIT,
    component: CustomerLeadAdd,
  },
  {
    path: '/walk-in/edit/:data_leads_id',
    exact: true,
    name: 'Chỉnh sửa Walk-in',
    function: PERMISSION.EDIT,
    component: CustomerLeadAdd,
  },
  {
    path: '/customer-lead/detail/:data_leads_id',
    exact: true,
    name: 'Chi tiết lead cá nhân',
    function: PERMISSION.VIEW,
    component: CustomerLeadAdd,
  },
  {
    path: '/lead-individual/detail/:data_leads_id',
    exact: true,
    name: 'Chi tiết lead cá nhân',
    function: PERMISSION.VIEW,
    component: CustomerLeadAdd,
  },
  {
    path: '/lead-business/detail/:data_leads_id',
    exact: true,
    name: 'Chi tiết lead doanh nghiệp',
    function: PERMISSION.VIEW,
    component: CustomerLeadAdd,
  },
  {
    path: '/walk-in/detail/:data_leads_id',
    exact: true,
    name: 'Chi tiết Walk-in',
    function: PERMISSION.VIEW,
    component: CustomerLeadAdd,
  },
];

export default customerLeadRoute;
